import React from 'react';

export function ResumoCard({ label, value, icon, color, isMobile }) {
  return (
    <article
      className="forecast-summary-card"
      style={{ '--forecast-card-accent': color }}
      data-compact={isMobile ? 'true' : 'false'}
    >
      <span className="forecast-summary-icon" aria-hidden="true">{icon}</span>
      <div>
        <small>{label}</small>
        <strong>{value}</strong>
        <em>Previsão para hoje</em>
      </div>
    </article>
  );
}
